var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIncoming = function SvgIncoming(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43146 10.9899H9.0303C9.58538 10.9899 10.0354 11.4399 10.0354 11.9949C10.0354 12.55 9.58538 13 9.0303 13L4.00505 13C3.72751 13 3.47625 12.8875 3.29437 12.7056C3.11249 12.5237 3 12.2725 3 11.9949V6.9697C3 6.41462 3.44998 5.96465 4.00505 5.96465C4.56012 5.96465 5.0101 6.41462 5.0101 6.9697L5.0101 9.56854L11.2843 3.29437C11.6768 2.90188 12.3131 2.90188 12.7056 3.29437C13.0981 3.68687 13.0981 4.32323 12.7056 4.71573L6.43146 10.9899Z",
    fill: "#008C73"
  })));
};
export default SvgIncoming;